import { locationIdFormat } from "@redotech/redo-inventory-id";
import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const getProcessingReceivingBins = {
  name: "getProcessingReceivingBins" as const,
  input: z.object({
    locationId: locationIdFormat.schema,
    search: z.string().nullable(),
  }),
  output: z.array(
    z.object({ id: storageLocationIdFormat.schema, name: z.string() }),
  ),
};
